import SummaryCard from "./summary-card";
import { actions } from 'redux/reducers';
import { SentimentType } from "types/sentiment";
import { useDispatch } from "react-redux";
import './summary.scss';

function Summary({
    sentiment,
    loading
} : {
    sentiment: SentimentType[],
    loading: boolean
}){
    const dispatch = useDispatch();

    const onClick = async (id: number) => {

        var data = [{}];

        if (id === 5){
            data = sentiment;
        } else {
            data = sentiment.filter(x => x.BrandAssociationId === id);
        }
        
        dispatch(actions.clipTray.set({
            open: true,
            clips: data
        }))
    }

    function getAverageSentiment(brandAssociationId: number){

        var brandSentiment: number[];
        var most = 0;
        
        if (brandAssociationId == 5){
            brandSentiment = sentiment.map(x => x.ClassificationId);
        } else 
        {
            brandSentiment = sentiment.filter(a => a.BrandAssociationId === brandAssociationId).map(x => x.ClassificationId);
        }

        const hashmap = brandSentiment.reduce( (acc: any, val: any) => {
            acc[val] = (acc[val] || 0 ) + 1
            return acc
         },{});
         if (Object.keys(hashmap).length > 0){
            most = parseInt(Object.keys(hashmap).reduce((a, b) => hashmap[a] > hashmap[b] ? a : b));
         }

        return most;
    }

    return (
        <div className="summary">
             <SummaryCard 
                    loading={loading} 
                    contentType={"Owned"}
                    sentiment={getAverageSentiment(1)} 
                    onClick={() => onClick(1)}
             />
             <SummaryCard 
                    loading={loading} 
                    contentType={"Earned"}
                    sentiment={getAverageSentiment(2)} 
                    onClick={() => onClick(2)}
             />
             <SummaryCard 
                    loading={loading} 
                    contentType={"Chatter"}
                    sentiment={getAverageSentiment(3)} 
                    onClick={() => onClick(3)}
             />
             <SummaryCard 
                    loading={loading} 
                    contentType={"All"}
                    sentiment={getAverageSentiment(5)} 
                    onClick={() => onClick(5)}
             />
        </div>
    )
}

export default Summary;